import { IDmLoaiThuNhapHocRequest } from "../../model/request/category/dmLoaiThuNhapHocRequest";
import { IDmLoaiThuNhapHoc } from "../../model/respone/category/IDmLoaiThuNhapHoc";
import { apiClient } from "../apiClient";
export const LOAI_THU_NHAP_HOC_ENDPOINT = "loai-thu-nhap-hoc";

/**
 * Phạm vi (hệ / ngành / chuyên ngành) người dùng tự khai cho một năm + đợt nhập học.
 * Cây phạm vi mặc định suy từ danh sách nhập học; chưa có hồ sơ nào thì cây rỗng,
 * không khai được mức thu trước — phần này để khai tay.
 */
export interface IPhamViNhapHocItem {
  id_pham_vi: number;
  id_he: number;
  id_nganh: number;
  id_chuyen_nganh: number;
}

export interface IPhamViNhapHocRequest {
  nam_nhap_hoc: number;
  dot_nhap_hoc: number;
  items?: IPhamViNhapHocItem[];
  ids?: number[];
}
/**
 * Một dòng của bản đồ DANH MỤC -> TRƯỜNG ĐÀO TẠO.
 * Đơn vị nhiều trường/phân hiệu khai danh mục theo từng trường: hệ cho biết trường, chuyên ngành
 * cũng có trường riêng. ⚠ Đơn vị không có bảng dmTruongDaoTao / cột IdTruong -> API trả RỖNG,
 * nghĩa là "không phân trường" và KHÔNG được lọc gì.
 */
export interface IDanhMucIdTruong {
  /** "he" | "chuyen_nganh" | "khoa" | "co_so" (ngành CỐ Ý không có — ngành dùng chung giữa các trường). */
  loai: string;
  id: number;
  id_truong: number;
}

export const loaiThuNhapHocApi = {
  SelectDanhMucTruong: () =>
    apiClient.get(`${LOAI_THU_NHAP_HOC_ENDPOINT}/danh-muc-truong`),
  SelectViewModelAll: () => apiClient.get(`${LOAI_THU_NHAP_HOC_ENDPOINT}`),
  Insert: (payload: IDmLoaiThuNhapHoc) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}`, payload),
  Update: (payload: IDmLoaiThuNhapHoc) =>
    apiClient.put(`${LOAI_THU_NHAP_HOC_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${LOAI_THU_NHAP_HOC_ENDPOINT}/${id}`),
  DeleteMany: (ids: number[]) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/delete-many`, ids),
  SelectHeNganhsByDot: (payload: IDmLoaiThuNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/select-he-nganhs`, payload),
  InsertMultiple: (payload: IDmLoaiThuNhapHoc[]) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/insert-multiple`, payload),
  SelectByDot: (payload: IDmLoaiThuNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/select-by-dot`, payload),
  SelectPhamVi: (payload: IPhamViNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/pham-vi/select`, payload),
  ThemPhamVi: (payload: IPhamViNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/pham-vi/them`, payload),
  XoaPhamVi: (payload: IPhamViNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/pham-vi/xoa`, payload),
};
